<template>
  <div>
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Inspección Visual</h6>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button
            size="sm"
            type="neutral"
            @click="exportData()"
            :loading="loading"
          >Exportar</base-button>
        </div>
      </div>
      <!-- Card stats -->
      <div class="row pt-1">
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="No Completadas"
            type="gradient-info"
            :sub-title="kpis.no_completadas.toString()"
            icon="ni ni-fat-remove"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{ calcularPorcentaje(kpis.no_completadas) }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Con Incidencia"
            type="gradient-red"
            :sub-title="kpis.con_incidencia.toString()"
            icon="ni ni-sound-wave"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{ calcularPorcentaje(kpis.con_incidencia) }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Pendientes"
            type="gradient-orange"
            :sub-title="kpis.pendientes.toString()"
            icon="ni ni-watch-time"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{ calcularPorcentaje(kpis.pendientes) }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card
            title="Completadas"
            type="gradient-green"
            :sub-title="kpis.completadas.toString()"
            icon="ni ni-check-bold"
          >
            <template slot="footer">
              <span class="text-success mr-2">{{ calcularPorcentaje(kpis.completadas) }}%</span>
              <span class="text-nowrap">del total</span>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--4">
      <div class="row">
        <div class="col">
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <div class="p-2">
              <div class="row col-12 d-flex justify-content-between flex-wrap">
                <div class="col-md-4">
                  <div>
                    <form>
                      <base-input
                        v-model="query"
                        type="search"
                        prepend-icon="fas fa-search"
                        placeholder="Buscar por nombre, apellidos, email..."
                        clearable
                      />
                    </form>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-6">
                      <el-select
                        v-model="mes"
                        placeholder="Mes"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="(nombre, index) in meses"
                          :key="index + 1"
                          :label="nombre"
                          :value="(index + 1).toString().padStart(2, '0')"
                        />
                      </el-select>
                    </div>
                    <div class="col-6">
                      <el-select
                        v-model="anio"
                        placeholder="Año"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="year in years"
                          :key="year"
                          :label="year"
                          :value="year"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="estado"
                    placeholder="Estado"
                    style="width: 100%"
                    @change="getList"
                  >
                    <el-option
                      v-for="item in estados"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </div>

              <!-- TABLA DE INSPECCIONES -->
              <el-table
                ref="multipleTable"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="empleados"
                @sort-change="sortChange"
                empty-text="No hay ningún elemento en esta tabla"
              >
                <!-- LOADING-->
                <div slot="empty" v-if="loading">
                  <img
                    src="/img/loading.gif"
                    style="height: 100px; width: 100px"
                  />
                </div>

                <el-table-column
                  label="Nombre y apellidos"
                  prop="nombre"
                  sortable="custom"
                  min-width="200px"
                >
                  <template v-slot="{ row }">
                    <img
                      v-if="row.imagen_perfil && row.imagen_perfil.url"
                      :src="row.imagen_perfil.url"
                      class="avatar rounded-circle mr-2"
                    />
                    <img
                      v-else
                      src="/img/placeholder.png"
                      class="avatar rounded-circle mr-2"
                    />
                    <b>{{ row.nombre + " " + row.apellidos }}</b>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Estado"
                  min-width="70px"
                  prop="estado"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    <span
                      class="badge badge-default"
                      :class="getEstadoBadgeClass(row)"
                    >
                      {{ getEstadoText(row) }}
                      <i v-if="hasResolvedInspections(row)" class="fa fa-comment ml-1" title="Observaciones resueltas"></i>
                    </span>
                  </template>
                </el-table-column>

                <el-table-column
                  label="Nº inspecciones"
                  min-width="100px"
                  prop="estadisticas.total"
                  sortable="custom"
                >
                  <template slot-scope="{ row }">
                    {{ row.estadisticas.total }}
                  </template>
                </el-table-column>

                <el-table-column
                  label="Completadas"
                  prop="completion"
                  min-width="120px"
                  sortable="custom"
                >
                  <template v-slot="{ row }">
                    <div class="d-flex align-items-center">
                      <span class="completion mr-2">{{ calcularPorcentajeCompletadas(row) }}%</span>
                      <div>
                        <base-progress
                          :value="calcularPorcentajeCompletadas(row)"
                          :type="getProgressType(calcularPorcentajeCompletadas(row))"
                        />
                      </div>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column label="Acciones" align="left">
                  <div slot-scope="{ row }" class="table-actions">
                    <base-button
                      outline
                      size="sm"
                      type="primary"
                      @click="verDetalles(row)"
                      style="padding-left: 10px; padding-right: 10px"
                    >Ver</base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import moment from "moment";
import "moment/locale/es";
moment.locale("es");
import axios from 'axios';

export default {
  name: "list-inspeccion-visual",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      empleados: [],
      loading: true,
      query: "",
      mes: moment().format("MM"),
      anio: moment().format("YYYY"),
      estado: "",
      sort: "-createdAt",
      kpis: {
        completadas: 0,
        pendientes: 0,
        con_incidencia: 0,
        no_completadas: 0,
        total: 0
      },
      estados: [
        { value: "", label: "Todos" },
        { value: "completada", label: "Completada" },
        { value: "con_incidencia", label: "Observaciones" },
        { value: "pendiente", label: "Pendiente" },
        { value: "no_completada", label: "No Completada" }
      ],
      meses: [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ],
      years: []
    };
  },
  created() {
    // Generar años desde 2020 hasta el año actual
    const currentYear = moment().year();
    for (let year = 2020; year <= currentYear; year++) {
      this.years.push(year.toString());
    }
    this.getList();
  },
  watch: {
    query: {
      handler: "getListDebounced",
      immediate: false
    },
    estado: {
      handler: "getList",
      immediate: false
    },
    mes: {
      handler: "getList",
      immediate: false
    },
    anio: {
      handler: "getList",
      immediate: false
    }
  },
  methods: {
    getListDebounced: _.debounce(function() {
      this.getList();
    }, 300),

    async getList() {
      this.loading = true;
      try {
        const planta = localStorage.getItem("plantaSelected");
        const token = localStorage.getItem("token");
        
        // Construir los parámetros de la consulta
        const params = {
          idEmpresa: planta // Parámetro obligatorio
        };

        // Añadir parámetros de ordenamiento
        if (this.sort) {
          params.sort = this.sort;
        }

        // Añadir filtros condicionales
        if (this.query) params.search = this.query;
        if (this.mes) params.mes = this.mes;
        if (this.anio) params.anio = this.anio;
        if (this.estado && this.estado !== "") params.estado = this.estado;
        
        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/inspeccion-visual-list`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params
        });

        if (response.data) {
          // Filtrar empleados que tienen al menos un equipo asignado (estadisticas.total > 0)
          this.empleados = (response.data.empleados || []).filter(empleado => 
            empleado.estadisticas && empleado.estadisticas.total > 0
          );
          
          // Procesar cada empleado para obtener información de inspecciones resueltas
          for (let empleado of this.empleados) {
            await this.loadEmployeeInspectionDetails(empleado);
          }
          
          // Actualizar los KPIs basados en los empleados filtrados
          this.kpis = response.data.kpis || {
            completadas: 0,
            pendientes: 0,
            con_incidencia: 0,
            no_completadas: 0,
            total: 0
          };
        } else {
          throw new Error('Formato de respuesta inválido');
        }
      } catch (error) {
        console.error("Error al cargar las inspecciones visuales:", error);
        this.$notify({
          type: "danger",
          title: "Error",
          message: error.response?.data?.error?.message || "No se pudieron cargar las inspecciones visuales. Por favor, inténtelo de nuevo.",
          duration: 5000
        });
      } finally {
        this.loading = false;
      }
    },

    async loadEmployeeInspectionDetails(empleado) {
      try {
        const planta = localStorage.getItem("plantaSelected");
        const token = localStorage.getItem("token");
        
        // Obtener las inspecciones del empleado
        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/inspeccion-visuals`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            'filters[users_permissions_user][id][$eq]': empleado.id,
            'filters[activo][empresa][id][$eq]': planta,
            'pagination[pageSize]': 100,
            'sort': 'createdAt:desc'
          }
        });

        if (response.data && response.data.data) {
          const inspecciones = response.data.data;
          
          // Verificar si hay inspecciones resueltas
          const hasResolvedInspections = inspecciones.some(insp => 
            insp.attributes.resolucion_tipo === 'resuelta'
          );
          
          // Añadir la información al empleado
          empleado.hasResolvedInspections = hasResolvedInspections;
          empleado.inspecciones = inspecciones;
        }
      } catch (error) {
        console.error(`Error al cargar detalles de inspecciones para empleado ${empleado.id}:`, error);
        empleado.hasResolvedInspections = false;
        empleado.inspecciones = [];
      }
    },

    formatEstado(estado) {
      const estados = {
        completada: "Completada",
        con_incidencia: "Observaciones",
        pendiente: "Pendiente",
        no_completada: "No Completada"
      };
      return estados[estado] || estado;
    },

    calcularPorcentaje(valor) {
      // El total real es la suma de las inspecciones activas (no retiradas)
      const totalActivos = this.kpis.completadas + 
                         this.kpis.pendientes + 
                         this.kpis.con_incidencia + 
                         this.kpis.no_completadas;
      
      return totalActivos ? Math.round((valor / totalActivos) * 100) : 0;
    },

    calcularPorcentajeCompletadas(row) {
      if (!row.estadisticas || !row.estadisticas.total) return 0;
      
      const completadas = row.estadisticas.completadas || 0;
      const conIncidencia = row.estadisticas.con_incidencia || 0;
      return Math.round(((completadas + conIncidencia) / row.estadisticas.total) * 100);
    },

    getProgressType(porcentaje) {
      if (porcentaje >= 90) return "success";
      if (porcentaje >= 50) return "warning";
      return "danger";
    },

    sortChange({ prop, order }) {
      if (!prop) return;
      
      // Mapeo de propiedades del frontend a backend
      const sortMapping = {
        'nombre': 'nombre',
        'estado': 'estado',
        'estadisticas.total': 'estadisticas.total',
        'completion': 'completion'
      };

      const field = sortMapping[prop] || prop;
      const direction = order === "descending" ? "desc" : "asc";
      this.sort = `${field}:${direction}`;
      this.getList();
    },

    verDetalles(row) {
      this.$router.push({
        name: "View Inspeccion Visual",
        params: { id: row.id, empleado: row }
      });
    },

    async exportData() {
      // Implementar la exportación de datos
    },

    getEstadoBadgeClass(row) {
      const estado = this.determineEmployeeStatus(row);
      switch (estado.status) {
        case 'completada':
          return 'badge-success';
        case 'con_incidencia':
          return 'badge-danger';
        case 'pendiente':
          return 'badge-warning';
        case 'no_completada':
          return 'badge-info';
        default:
          return 'badge-default';
      }
    },

    getEstadoText(row) {
      const estado = this.determineEmployeeStatus(row);
      return estado.text;
    },

    hasResolvedInspections(row) {
      const estado = this.determineEmployeeStatus(row);
      return estado.hasResolved;
    },

    determineEmployeeStatus(row) {
      // Si no hay estadísticas, mostrar como pendiente
      if (!row.estadisticas || !row.estadisticas.total) {
        return {
          status: 'pendiente',
          text: 'Pendiente',
          hasResolved: false
        };
      }

      const { completadas = 0, con_incidencia = 0, pendientes = 0, no_completadas = 0 } = row.estadisticas;
      const total = row.estadisticas.total;

      // PRIORIDAD 1: Si hay al menos una inspección con incidencia, mostrar "Observaciones"
      if (con_incidencia > 0) {
        return {
          status: 'con_incidencia',
          text: 'Observaciones',
          hasResolved: false
        };
      }

      // PRIORIDAD 2: Si hay inspecciones pendientes
      if (pendientes > 0) {
        return {
          status: 'pendiente',
          text: 'Pendiente',
          hasResolved: false
        };
      }

      // PRIORIDAD 3: Si hay inspecciones no completadas
      if (no_completadas > 0) {
        return {
          status: 'no_completada',
          text: 'No Completada',
          hasResolved: false
        };
      }

      // PRIORIDAD 4: Si todas las inspecciones están completadas
      if (completadas > 0 && (completadas + con_incidencia + pendientes + no_completadas) === total) {
        // Usar la información de inspecciones resueltas que cargamos
        const hasResolved = row.hasResolvedInspections || false;
        
        return {
          status: 'completada',
          text: 'Completada',
          hasResolved: hasResolved
        };
      }

      // Fallback
      return {
        status: 'pendiente',
        text: 'Pendiente',
        hasResolved: false
      };
    }
  }
};
</script>

<style>
.badge-success {
  background-color: #2dce89;
}
.badge-danger {
  background-color: #f5365c;
}
.badge-warning {
  background-color: #fb6340;
}
.badge-info {
  background-color: #11cdef;
}
</style> 